(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  /** UI option value for "Other"; OMS by-channel API expects `sunny_health_fitness` instead. */
  var OTHER_CHANNEL_CODE = 'other';
  var CHANNEL_KEY_FOR_OTHER_API = 'sunny_health_fitness';

  function resolveChannelKeyForApi(channelKey) {
    var k = String(channelKey || '').trim();
    if (k === OTHER_CHANNEL_CODE) {
      return CHANNEL_KEY_FOR_OTHER_API;
    }
    return k;
  }

  /** Inline SVG as data URL — no theme asset. */
  var SKU_THUMB_PLACEHOLDER_DATA_URL =
    'data:image/svg+xml,' +
    encodeURIComponent(
      '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" fill="none">' +
        '<rect width="34" height="34" rx="4" fill="#EFF1F4"/>' +
        '<rect x="10.88" y="11.56" width="5.78" height="6.68667" rx="1.088" fill="#BDC4CF"/>' +
        '<rect x="17.6801" y="16.4333" width="5.78" height="6.68667" rx="1.088" fill="#BDC4CF"/>' +
        '<rect x="17.5667" y="11.6733" width="6.12" height="3.96667" rx="1.088" fill="#BDC4CF"/>' +
        '<rect x="10.7666" y="19.1533" width="6.12" height="3.96667" rx="1.088" fill="#BDC4CF"/>' +
        '</svg>'
    );

  /** Substring or ordered subsequence match (e.g. "amzn" → "Amazon US"). */
  function channelLabelMatchesFuzzy(label, queryLower) {
    var a = String(label || '').toLowerCase();
    var b = String(queryLower || '').trim();
    if (!b) return true;
    if (a.indexOf(b) !== -1) return true;
    var aCompact = a.replace(/[\s&.'’\-]/g, '');
    var bCompact = b.replace(/[\s&.'’\-]/g, '');
    var bi = 0;
    var ai;
    for (ai = 0; ai < aCompact.length && bi < bCompact.length; ai++) {
      if (aCompact[ai] === bCompact[bi]) bi++;
    }
    if (bi === bCompact.length) return true;
    bi = 0;
    for (ai = 0; ai < a.length && bi < b.length; ai++) {
      if (a[ai] === b[bi]) bi++;
    }
    return bi === b.length;
  }

  function normalizeListingsPayload(json) {
    if (!json) return [];
    if (Array.isArray(json)) return json;
    var keys = ['data', 'rows', 'list', 'listings', 'records', 'result', 'content', 'items'];
    var i;
    for (i = 0; i < keys.length; i++) {
      var v = json[keys[i]];
      if (Array.isArray(v)) return v;
      if (v && typeof v === 'object' && Array.isArray(v.records)) return v.records;
    }
    return [];
  }

  /** Legacy OMS listings row (POST) — kept for compatibility if payload shape appears. */
  function normalizeRow(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var sku =
      raw.sku ||
      raw.SKU ||
      raw.sellerSku ||
      raw.merchantSku ||
      raw.productSku ||
      '';
    sku = String(sku).trim();
    if (!sku) return null;
    var title =
      raw.skuName ||
      raw.title ||
      raw.productTitle ||
      raw.name ||
      raw.itemName ||
      raw.productName ||
      raw.itemTitle ||
      '';
    return {
      sku: sku,
      productTitle: String(title || ''),
    };
  }

  /**
   * GET /review-sku/by-channel item:
   * { sku, channelSku?, link, channelProcuctImage, category }
   * `channelSku` is optional OMS-side string; omitted/empty rows match search by sku only.
   */
  function normalizeReviewSkuRow(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var sku = String(raw.sku || raw.SKU || '').trim();
    if (!sku) return null;
    var extCh =
      raw.channelSku != null
        ? String(raw.channelSku)
        : raw.channel_sku != null
          ? String(raw.channel_sku)
          : '';
    extCh = String(extCh || '').trim();
    var img =
      raw.channelProcuctImage ||
      raw.channelProductImage ||
      raw.productImage ||
      raw.image ||
      '';
    var link = raw.link || raw.reviewLink || '';
    var cat =
      raw.category ||
      raw.Category ||
      raw.productCategory ||
      '';
    return {
      sku: sku,
      channelSku: extCh,
      link: String(link || '').trim(),
      image: String(img || '').trim(),
      category: String(cat || '').trim(),
    };
  }

  function parseSkuRows(json) {
    var arr = normalizeListingsPayload(json);
    if (!arr.length && json && typeof json === 'object' && !Array.isArray(json) && json.sku) {
      arr = [json];
    }
    var rows = [];
    var seen = Object.create(null);
    var j;
    for (j = 0; j < arr.length; j++) {
      var raw = arr[j];
      var row = normalizeReviewSkuRow(raw);
      if (!row) {
        var legacy = normalizeRow(raw);
        if (legacy) {
          row = { sku: legacy.sku, channelSku: '', link: '', image: '', category: '' };
        }
      }
      if (row && !seen[row.sku]) {
        seen[row.sku] = true;
        rows.push(row);
      }
    }
    return rows;
  }

  function isEmptySkuSelectOption(opt) {
    return !opt || String(opt.value || '').trim() === '';
  }

  /**
   * Resolve trigger/submit text to canonical SKU value (option value).
   * Accepts exact sku or exact channelSku (case-insensitive) when channelSku is present in meta.
   */
  function resolveSkuSelectValueToCanonical(skuSelect, raw) {
    var v = String(raw || '').trim();
    if (!v || !skuSelect) return '';
    var j;
    for (j = 0; j < skuSelect.options.length; j++) {
      var o = skuSelect.options[j];
      if (isEmptySkuSelectOption(o)) continue;
      if (String(o.value || '').trim() === v) return v;
    }
    var mmap = skuSelect.__skuMetaMap;
    if (mmap) {
      var qNorm = v.toLowerCase();
      for (j = 0; j < skuSelect.options.length; j++) {
        o = skuSelect.options[j];
        if (isEmptySkuSelectOption(o)) continue;
        var key = String(o.value || '').trim();
        var row = mmap[key];
        if (row && String(row.channelSku || '').trim()) {
          if (String(row.channelSku).trim().toLowerCase() === qNorm) return key;
        }
      }
    }
    return v;
  }

  var KLAVIYO_CLIENT_SUBSCRIPTIONS_URL = 'https://a.klaviyo.com/client/subscriptions';

  function readConfig(root) {
    var id = root.getAttribute('data-section-id');
    var map = window.__amazonChannelFormConfigs || {};
    var cfg = (id && map[id]) || {};
    return {
      apiUrl:
        cfg.apiUrl ||
        'https://oms.sunnyhealthfitness.com/prod-api/api/amazonSc/review-sku/by-channel',
      klaviyoEventName: cfg.klaviyoEventName || 'Amazon Channel Lead Form Submitted',
      klaviyoCompanyId: cfg.klaviyoCompanyId || '',
      klaviyoListId: cfg.klaviyoListId || 'UU9HZ7',
      klaviyoApiRevision: cfg.klaviyoApiRevision || '2025-10-15',
      klaviyoProfileSource: cfg.klaviyoProfileSource,
      klaviyoCategoryDefault: cfg.klaviyoCategoryDefault || '',
      klaviyoAgreeTermsLabel: cfg.klaviyoAgreeTermsLabel || 'Agree Warranty Terms',
    };
  }

  /** E.164 only; otherwise phone stays in custom properties only. */
  var E164_PHONE_RE = /^\+[1-9]\d{1,14}$/;

  function buildKlaviyoClientSubscriptionPayload(listId, email, firstName, lastName, phoneE164, customProps) {
    var attrs = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      properties: customProps || {},
    };
    if (phoneE164 && E164_PHONE_RE.test(String(phoneE164).trim())) {
      attrs.phone_number = String(phoneE164).trim();
    }
    return {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Amazon Channel Warranty Form (Shopify)',
          profile: {
            data: {
              type: 'profile',
              attributes: attrs,
            },
          },
        },
        relationships: {
          list: {
            data: {
              type: 'list',
              id: String(listId || '').trim(),
            },
          },
        },
      },
    };
  }

  function klaviyoClientSubscribe(cfg, payload) {
    var companyId = String(cfg.klaviyoCompanyId || '').trim();
    if (!companyId) {
      return Promise.reject(new Error('MISSING_KLAVIYO_PUBLIC_KEY'));
    }
    var url =
      KLAVIYO_CLIENT_SUBSCRIPTIONS_URL + '?company_id=' + encodeURIComponent(companyId);
    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        accept: 'application/vnd.api+json',
        'content-type': 'application/vnd.api+json',
        revision: String(cfg.klaviyoApiRevision || '2025-10-15').trim(),
      },
      body: JSON.stringify(payload),
    }).then(function (res) {
      if (res.status === 202) {
        return res;
      }
      return res.text().then(function (txt) {
        var err = new Error('KLAVIYO_HTTP_' + res.status);
        err.status = res.status;
        err.bodyText = txt;
        try {
          err.bodyJson = JSON.parse(txt);
        } catch (e1) {}
        throw err;
      });
    });
  }

  function formatKlaviyoSubscribeError(err) {
    if (!err) {
      return 'Something went wrong. Please try again.';
    }
    if (err.message === 'MISSING_KLAVIYO_PUBLIC_KEY') {
      return 'Klaviyo is not configured: add your Public API key (Site ID) in the section settings.';
    }
    if (err.bodyJson && err.bodyJson.errors && err.bodyJson.errors.length) {
      var e0 = err.bodyJson.errors[0];
      return String(e0.detail || e0.title || 'Subscription failed.').trim();
    }
    if (err.status === 403 || err.status === 401) {
      return 'Klaviyo rejected the request. Check your Public API key and List ID.';
    }
    return 'Could not subscribe to the list. Please try again.';
  }

  function buildReviewSkuRequestUrl(baseUrl, channel, category) {
    var base = String(baseUrl || '').trim();
    if (!base) {
      base =
        'https://oms.sunnyhealthfitness.com/prod-api/api/amazonSc/review-sku/by-channel';
    }
    var join = base.indexOf('?') >= 0 ? '&' : '?';
    var q = ['channel=' + encodeURIComponent(String(channel || '').trim())];
    var cat = String(category || '').trim();
    if (cat) {
      q.push('category=' + encodeURIComponent(cat));
    }
    return base + join + q.join('&');
  }

  function fetchSkusForChannel(cfg, channel) {
    var cat = String((cfg && cfg.klaviyoCategoryDefault) || '').trim();
    var url = buildReviewSkuRequestUrl(cfg.apiUrl, channel, cat);
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        Accept: 'application/json',
      },
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) {
          throw new Error(json && json.message ? String(json.message) : 'Request failed');
        }
        if (json && json.code !== undefined && json.code !== null && json.code !== '') {
          var cn = Number(json.code);
          if (!isNaN(cn) && cn !== 200) {
            throw new Error('Could not load SKUs for this channel.');
          }
        }
        return json;
      });
    });
  }

  function setFormMessage(el, type, text) {
    if (!el) return;
    el.textContent = text || '';
    el.setAttribute('data-state', type || '');
    if (!text) {
      el.setAttribute('hidden', '');
    } else {
      el.removeAttribute('hidden');
    }
  }

  var ACF_INLINE_ERR_EMAIL = 'Please enter a valid email.';

  function setAcfFieldErrorVisible(errEl, visible, text) {
    if (!errEl) return;
    if (text !== undefined && text !== null) {
      errEl.textContent = String(text);
    }
    if (visible) {
      errEl.removeAttribute('hidden');
    } else {
      errEl.setAttribute('hidden', '');
    }
  }

  function clearAcfInlineFieldErrors(form) {
    if (!form) return;
    var emailErr = form.querySelector('[data-acf-field-error="email"]');
    var emailWrap = form.querySelector('[data-acf-email-wrap]');
    setAcfFieldErrorVisible(emailErr, false);
    if (emailWrap) emailWrap.classList.remove('is-invalid');
  }

  /**
   * Custom searchable combobox synced to a native <select> (for styling + filter).
   * Markup: select + [data-acf-combobox-trigger] + panel + list; optional [data-acf-combobox-search] in panel.
   * opts.inputTrigger: SKU trigger is an <input>; click toggles the panel (avoids mobile stuck-open); panel search filters while open; trigger value filters when closed.
   */
  function attachSearchableCombobox(select, opts) {
    opts = opts || {};
    var richSku = !!opts.richSku;
    var richChannel = !!opts.richChannel;

    function getOptionMediaMap() {
      if (richSku) return select.__skuMetaMap;
      if (richChannel) return select.__channelMetaMap;
      return null;
    }

    if (!select) return;
    var wrap = select.closest('[data-acf-combobox]');
    if (!wrap) return;
    var trigger = wrap.querySelector('[data-acf-combobox-trigger]');
    var inputTrigger = !!opts.inputTrigger && trigger && trigger.tagName === 'INPUT';
    var display = inputTrigger ? null : wrap.querySelector('[data-acf-combobox-display]');
    var panel = wrap.querySelector('[data-acf-combobox-panel]');
    var panelSearch = wrap.querySelector('[data-acf-combobox-search]');
    var search = panelSearch || (inputTrigger ? trigger : null);
    var list = wrap.querySelector('[data-acf-combobox-list]');
    var shell = wrap.querySelector('.acf-combobox__shell');
    var isSkuPanel = wrap.classList.contains('acf-combobox--sku');
    if (!trigger || (!display && !inputTrigger) || !panel || !list) return;

    /** SKU text trigger: show selected row thumbnail to the left of the value (same assets as dropdown). */
    var inputThumbWrap = null;
    if (inputTrigger && isSkuPanel && richSku && shell) {
      inputThumbWrap = shell.querySelector('[data-acf-combobox-input-thumb-wrap]');
      if (!inputThumbWrap) {
        inputThumbWrap = document.createElement('span');
        inputThumbWrap.setAttribute('data-acf-combobox-input-thumb-wrap', '');
        inputThumbWrap.className = 'acf-combobox__input-thumb-wrap';
        inputThumbWrap.setAttribute('aria-hidden', 'true');
        inputThumbWrap.setAttribute('hidden', '');
        var thumbImg = document.createElement('img');
        thumbImg.className = 'acf-combobox__thumb';
        thumbImg.alt = '';
        thumbImg.setAttribute('loading', 'lazy');
        inputThumbWrap.appendChild(thumbImg);
        shell.insertBefore(inputThumbWrap, trigger);
      }
    }

    var searchable;
    if (opts.searchable !== undefined) {
      searchable = !!opts.searchable;
    } else {
      searchable = wrap.getAttribute('data-acf-combobox-searchable') !== 'false';
    }
    if (searchable && !search) return;

    var open = false;

    function isPlaceholderOption(opt) {
      return !opt || String(opt.value || '').trim() === '';
    }

    function syncSelectToMatchingOptionValue() {
      if (!inputTrigger) return;
      var v = String(trigger.value || '').trim();
      if (!v) {
        select.selectedIndex = 0;
        return;
      }
      var j;
      for (j = 0; j < select.options.length; j++) {
        var o = select.options[j];
        if (isPlaceholderOption(o)) continue;
        if (String(o.value || '').trim() === v) {
          select.selectedIndex = j;
          return;
        }
      }
      if (richSku && isSkuPanel) {
        var mmapSyn = getOptionMediaMap();
        if (mmapSyn) {
          var qLow = v.toLowerCase();
          for (j = 0; j < select.options.length; j++) {
            o = select.options[j];
            if (isPlaceholderOption(o)) continue;
            var valK = String(o.value || '').trim();
            var rowSyn = mmapSyn[valK];
            if (
              rowSyn &&
              String(rowSyn.channelSku || '').trim() &&
              String(rowSyn.channelSku).trim().toLowerCase() === qLow
            ) {
              select.selectedIndex = j;
              return;
            }
          }
        }
      }
      select.selectedIndex = 0;
    }

    function getDisplayState() {
      var i = select.selectedIndex;
      var opt = i >= 0 ? select.options[i] : null;
      var selOk = opt && !isPlaceholderOption(opt);
      if (inputTrigger && selOk) {
        return { text: String(opt.textContent || '').trim(), placeholder: false };
      }
      if (inputTrigger && trigger) {
        var tv = String(trigger.value || '').trim();
        if (tv) {
          return { text: tv, placeholder: false };
        }
      }
      if (!opt || isPlaceholderOption(opt)) {
        return { text: '', placeholder: true };
      }
      return { text: String(opt.textContent || '').trim(), placeholder: false };
    }

    function syncDisplay() {
      var st = getDisplayState();
      if (inputTrigger) {
        if (st.placeholder) {
          trigger.value = '';
          trigger.classList.add('is-placeholder');
        } else {
          trigger.value = st.text;
          trigger.classList.remove('is-placeholder');
        }
        if (inputThumbWrap) {
          var mmapIn = getOptionMediaMap();
          var tvIn = String(trigger.value || '').trim();
          var svIn = String(select.value || '').trim();
          var metaKey =
            svIn && svIn === tvIn ? svIn : tvIn && mmapIn && mmapIn[tvIn] ? tvIn : '';
          var rowIn = metaKey && mmapIn ? mmapIn[metaKey] : null;
          var srcIn = rowIn ? String(rowIn.image || '').trim() : '';
          if (richSku && !srcIn && metaKey) {
            srcIn = String(select.__skuThumbPlaceholderUrl || '').trim();
          }
          var imgIn = inputThumbWrap.querySelector('img');
          if (!st.placeholder && metaKey && srcIn && imgIn) {
            imgIn.src = srcIn;
            inputThumbWrap.removeAttribute('hidden');
            trigger.classList.add('has-sku-inline-thumb');
          } else {
            inputThumbWrap.setAttribute('hidden', '');
            trigger.classList.remove('has-sku-inline-thumb');
          }
        }
        return;
      }
      var mmapDisp = getOptionMediaMap();
      if ((richSku || richChannel) && mmapDisp && !st.placeholder) {
        var meta = mmapDisp[select.value];
        if (meta && meta.image) {
          display.innerHTML = '';
          display.classList.remove('is-placeholder');
          var inner = document.createElement('span');
          inner.className =
            'acf-combobox__value-inner acf-combobox__value-inner--media' +
            (richChannel ? ' acf-combobox__value-inner--channel' : '');
          var img = document.createElement('img');
          img.className = 'acf-combobox__thumb' + (richChannel ? ' acf-combobox__thumb--channel' : '');
          img.setAttribute('loading', 'lazy');
          img.src = meta.image;
          img.alt = '';
          var tx = document.createElement('span');
          tx.className = 'acf-combobox__value-text';
          tx.textContent = st.text;
          inner.appendChild(img);
          inner.appendChild(tx);
          display.appendChild(inner);
          return;
        }
      }
      display.innerHTML = '';
      display.textContent = st.text;
      if (st.placeholder) {
        display.classList.add('is-placeholder');
      } else {
        display.classList.remove('is-placeholder');
      }
    }

    function syncTriggerDisabled() {
      if (isSkuPanel && inputTrigger) {
        return;
      }
      if (isSkuPanel) {
        trigger.disabled = false;
        return;
      }
      trigger.disabled = !!select.disabled;
    }

    function buildList(filterStr) {
      list.innerHTML = '';
      if (isSkuPanel && select.__acfSkuPanel) {
        var p = select.__acfSkuPanel;
        if (p.mode === 'manual_input') {
          list.innerHTML = '';
          if (isSkuPanel) {
            select.__acfSkuVisibleCount = 0;
            select.__acfSkuOptionTotal = 0;
          }
          return;
        }
        if (p.mode !== 'ready') {
          var hint = document.createElement('li');
          hint.className = 'acf-combobox__empty acf-combobox__hint';
          hint.setAttribute('role', 'status');
          var msg = '';
          if (p.mode === 'need_channel') {
            msg = 'Please select a purchase channel first.';
          } else if (p.mode === 'loading') {
            msg = 'Loading SKUs...';
          } else if (p.mode === 'error') {
            msg = p.message || 'Could not load SKUs. Please try again.';
          } else if (p.mode === 'empty') {
            msg = p.message || 'No SKUs returned for this channel.';
          } else {
            msg = p.message || 'No options available.';
          }
          hint.textContent = msg;
          list.appendChild(hint);
          if (isSkuPanel) {
            select.__acfSkuVisibleCount = 0;
            select.__acfSkuOptionTotal = 0;
          }
          return;
        }
      }
      var totalNonPlaceholder = 0;
      if (isSkuPanel) {
        for (var t = 0; t < select.options.length; t++) {
          if (!isPlaceholderOption(select.options[t])) {
            totalNonPlaceholder++;
          }
        }
      }
      var q = String(filterStr || '').trim().toLowerCase();
      var added = 0;
      var i;

      function appendOptionRow(ix) {
        var opt = select.options[ix];
        if (isPlaceholderOption(opt)) {
          return 0;
        }
        var label = String(opt.textContent || '').trim();
        var val = String(opt.value || '');
        var li = document.createElement('li');
        li.setAttribute('role', 'option');
        li.className = 'acf-combobox__option';
        li.setAttribute('data-index', String(ix));

        var mmapList = getOptionMediaMap();
        if ((richSku || richChannel) && mmapList) {
          var rowMeta = mmapList[val];
          var thumbSrc = '';
          if (rowMeta) {
            thumbSrc = String(rowMeta.image || '').trim();
          }
          if (richSku && !thumbSrc) {
            thumbSrc = String(select.__skuThumbPlaceholderUrl || '').trim();
          }
          if (thumbSrc) {
            li.classList.add('acf-combobox__option--media');
            if (richChannel) {
              li.classList.add('acf-combobox__option--channel');
            }
            var thumb = document.createElement('img');
            thumb.className = 'acf-combobox__thumb' + (richChannel ? ' acf-combobox__thumb--channel' : '');
            thumb.setAttribute('loading', 'lazy');
            thumb.src = thumbSrc;
            thumb.alt = '';
            var optText = document.createElement('span');
            optText.className = 'acf-combobox__option-text';
            optText.textContent = label;
            li.appendChild(thumb);
            li.appendChild(optText);
          } else {
            li.textContent = label;
          }
        } else {
          li.textContent = label;
        }

        list.appendChild(li);
        return 1;
      }

      if (richChannel && !isSkuPanel && q) {
        var matchedIdx = [];
        var otherIdx = -1;
        for (i = 0; i < select.options.length; i++) {
          var chOpt = select.options[i];
          if (isPlaceholderOption(chOpt)) {
            continue;
          }
          var chVal = String(chOpt.value || '').trim();
          if (chVal === 'other') {
            otherIdx = i;
            continue;
          }
          var chLabel = String(chOpt.textContent || '').trim();
          if (channelLabelMatchesFuzzy(chLabel, q)) {
            matchedIdx.push(i);
          }
        }
        if (otherIdx >= 0) {
          matchedIdx.push(otherIdx);
        }
        for (i = 0; i < matchedIdx.length; i++) {
          added += appendOptionRow(matchedIdx[i]);
        }
      } else {
        for (i = 0; i < select.options.length; i++) {
          var opt = select.options[i];
          if (isPlaceholderOption(opt)) {
            continue;
          }
          var label = String(opt.textContent || '').trim();
          var optValRow = String(opt.value || '').trim();
          if (q) {
            var labelHit = label.toLowerCase().indexOf(q) !== -1;
            var channelSkuHit = false;
            if (richSku && isSkuPanel) {
              var mmapSku = getOptionMediaMap();
              if (mmapSku && optValRow) {
                var rowSku = mmapSku[optValRow];
                var csPart = rowSku && String(rowSku.channelSku || '').trim();
                if (csPart) {
                  channelSkuHit = csPart.toLowerCase().indexOf(q) !== -1;
                }
              }
            }
            if (!labelHit && !channelSkuHit) {
              continue;
            }
          }
          added += appendOptionRow(i);
        }
      }
      if (isSkuPanel) {
        select.__acfSkuVisibleCount = added;
        select.__acfSkuOptionTotal = totalNonPlaceholder;
      }
      if (!added) {
        var empty = document.createElement('li');
        empty.className = 'acf-combobox__empty';
        empty.textContent = 'No matches';
        list.appendChild(empty);
      }
      if (isSkuPanel && open && !skuUseSimpleDropdown()) {
        scheduleSkuLayout();
      }
    }

    function filterQuery() {
      if (!searchable) return '';
      if (open && panelSearch) {
        return String(panelSearch.value || '');
      }
      if (!open && inputTrigger && trigger) {
        return String(trigger.value || '');
      }
      return search ? String(search.value || '') : '';
    }

    function refresh() {
      syncDisplay();
      syncTriggerDisabled();
      if (isSkuPanel && select.__acfSkuPanel) {
        wrap.setAttribute('data-acf-sku-panel-mode', select.__acfSkuPanel.mode);
      } else {
        wrap.removeAttribute('data-acf-sku-panel-mode');
      }
      buildList(filterQuery());
    }

    var skuLayoutTimer = null;

    function resetSkuPanelLayout() {
      if (!isSkuPanel || !panel) return;
      panel.style.cssText = '';
      if (wrap) {
        wrap.classList.remove('acf-combobox--sku-float-bottom');
      }
    }

    /** SKU full-screen-style panel only after a channel is chosen; before that, use a normal compact dropdown. */
    function skuUseSimpleDropdown() {
      return (
        isSkuPanel &&
        select.__acfSkuPanel &&
        select.__acfSkuPanel.mode === 'need_channel'
      );
    }

    /**
     * SKU panel placement:
     * - Ready + full list (not client-filtered): fixed 400px under the trigger.
     * - Ready + filtered: >8 visible rows → 400px; else measured height.
     * - Non-ready (loading / error / empty hint): measured height only — avoids a 400px-tall panel for one line.
     * - No viewport/bottom-distance clamping or bottom-sheet fallback.
     */
    function positionSkuPanel() {
      if (!isSkuPanel || !shell) return;
      if (select.__acfSkuPanel && select.__acfSkuPanel.mode === 'need_channel') {
        return;
      }
      resetSkuPanelLayout();

      var SKU_PANEL_MAX_PX = 400;
      var SKU_PANEL_MIN_PX = 60;
      /** Above this many visible rows while filtering, keep panel at max height so the list scrolls inside. */
      var SKU_FULL_PANEL_VISIBLE_THRESHOLD = 8;

      var gap = 4;

      var skuPanelMode = select.__acfSkuPanel && select.__acfSkuPanel.mode;
      var skuListReady = skuPanelMode === 'ready';

      var visibleSkuRows =
        typeof select.__acfSkuVisibleCount === 'number'
          ? select.__acfSkuVisibleCount
          : 0;
      var totalSkuOptions =
        typeof select.__acfSkuOptionTotal === 'number'
          ? select.__acfSkuOptionTotal
          : visibleSkuRows;

      /** List is narrowed vs full SKU set (client-side filter), using counts from buildList. */
      var searchFilterActive = totalSkuOptions > visibleSkuRows;

      var natural;
      if (skuListReady && !searchFilterActive) {
        natural = SKU_PANEL_MAX_PX;
      } else if (skuListReady && searchFilterActive && visibleSkuRows > SKU_FULL_PANEL_VISIBLE_THRESHOLD) {
        natural = SKU_PANEL_MAX_PX;
      } else {
        panel.style.height = 'auto';
        panel.style.minHeight = '0';
        panel.style.maxHeight = 'none';
        if (list) {
          list.style.maxHeight = 'none';
        }
        natural = Math.ceil(panel.scrollHeight || 0);
        if (list) {
          list.style.maxHeight = '';
        }
        natural = Math.min(Math.max(natural, SKU_PANEL_MIN_PX), SKU_PANEL_MAX_PX);
      }

      panel.style.position = 'absolute';
      panel.style.left = '0';
      panel.style.right = '0';
      panel.style.width = '';
      panel.style.top = 'calc(100% + ' + gap + 'px)';
      panel.style.bottom = 'auto';
      panel.style.height = natural + 'px';
      panel.style.maxHeight = natural + 'px';
      panel.style.zIndex = '900';
      panel.style.transform = '';
    }

    function scheduleSkuLayout() {
      if (!open || !isSkuPanel) return;
      if (skuLayoutTimer) {
        clearTimeout(skuLayoutTimer);
      }
      skuLayoutTimer = setTimeout(function () {
        skuLayoutTimer = null;
        positionSkuPanel();
      }, 32);
    }

    function setOpen(v) {
      open = v;
      if (v) {
        wrap.classList.add('is-open');
        if (isSkuPanel && skuUseSimpleDropdown()) {
          resetSkuPanelLayout();
        }
        panel.removeAttribute('hidden');
        trigger.setAttribute('aria-expanded', 'true');
        if (panelSearch) {
          if (isSkuPanel && inputTrigger) {
            panelSearch.value = '';
          } else if (inputTrigger && trigger) {
            panelSearch.value = String(trigger.value || '').trim();
          } else {
            panelSearch.value = '';
          }
        } else if (search && !inputTrigger) {
          search.value = '';
        }
        buildList(filterQuery());
        if (isSkuPanel && !skuUseSimpleDropdown()) {
          requestAnimationFrame(function () {
            positionSkuPanel();
            requestAnimationFrame(positionSkuPanel);
          });
        }
        setTimeout(function () {
          if (searchable && search) {
            var hideSkuSearch =
              isSkuPanel &&
              select.__acfSkuPanel &&
              select.__acfSkuPanel.mode !== 'ready';
            if (!hideSkuSearch) {
              search.focus();
            }
          }
        }, 0);
      } else {
        wrap.classList.remove('is-open');
        panel.setAttribute('hidden', '');
        trigger.setAttribute('aria-expanded', 'false');
        if (panelSearch) {
          panelSearch.value = '';
        }
        if (isSkuPanel) {
          resetSkuPanelLayout();
        }
      }
    }

    function applyIndex(index) {
      if (index < 0 || index >= select.options.length) return;
      select.selectedIndex = index;
      var ev = document.createEvent('Event');
      ev.initEvent('change', true, true);
      select.dispatchEvent(ev);
      syncDisplay();
      setOpen(false);
    }

    /**
     * Text trigger: open on pointerdown (first tap may not emit click).
     * Ignore the paired click after pointerdown-open so it does not immediately close again.
     */
    var openedTriggerViaPointerDown = false;
    if (inputTrigger) {
      trigger.addEventListener('pointerdown', function (e) {
        if (trigger.disabled) return;
        if (e.button !== undefined && e.button !== 0) return;
        if (!open) {
          openedTriggerViaPointerDown = true;
          setOpen(true);
        } else {
          openedTriggerViaPointerDown = false;
        }
      });
      trigger.addEventListener('click', function () {
        if (trigger.disabled) return;
        if (openedTriggerViaPointerDown) {
          openedTriggerViaPointerDown = false;
          return;
        }
        if (open) {
          setOpen(false);
        }
      });
    } else {
      trigger.addEventListener('click', function (e) {
        if (trigger.disabled) return;
        e.preventDefault();
        setOpen(!open);
      });
    }

    function activateOptionFromEvent(e) {
      if (e.button !== undefined && e.button !== 0) return;
      var node = e.target;
      var item = node && node.closest ? node.closest('.acf-combobox__option') : null;
      if (!item || !list.contains(item)) return;
      var ix = parseInt(item.getAttribute('data-index'), 10);
      if (isNaN(ix)) return;
      e.preventDefault();
      applyIndex(ix);
    }

    list.addEventListener('pointerdown', activateOptionFromEvent);
    list.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.acf-combobox__option')) {
        e.preventDefault();
      }
    });

    if (searchable && search) {
      search.addEventListener('input', function () {
        buildList(filterQuery());
      });
    }

    if (inputTrigger && trigger) {
      trigger.addEventListener('input', function () {
        syncSelectToMatchingOptionValue();
        refresh();
      });
      trigger.addEventListener('blur', function () {
        syncSelectToMatchingOptionValue();
        refresh();
      });
    }

    function dismissComboboxIfOutside(e) {
      if (!open) return;
      if (wrap.contains(e.target)) return;
      setOpen(false);
    }

    /** Defer so pointerdown/click on list options runs before close (mobile touchend is before click). */
    function dismissComboboxIfOutsideDeferred(e) {
      if (!open) return;
      if (wrap.contains(e.target)) return;
      var target = e.target;
      setTimeout(function () {
        if (!open) return;
        if (target && wrap.contains(target)) return;
        setOpen(false);
      }, 0);
    }

    document.addEventListener('click', dismissComboboxIfOutside);
    if (isSkuPanel && inputTrigger) {
      document.addEventListener('touchend', dismissComboboxIfOutsideDeferred, { passive: true });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !open) return;
      var ae = document.activeElement;
      if (wrap.contains(ae)) {
        setOpen(false);
        trigger.focus();
      }
    });

    if (isSkuPanel) {
      window.addEventListener('resize', scheduleSkuLayout);
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', scheduleSkuLayout);
        window.visualViewport.addEventListener('scroll', scheduleSkuLayout);
      }
    }

    select.__acfComboboxRefresh = refresh;
    refresh();
  }

  /** Legacy Klaviyo `$source` (e.g. -5). */
  function parseKlaviyoProfileSource(raw) {
    if (raw === undefined || raw === null || raw === '') {
      return -5;
    }
    var n = Number(raw);
    return isNaN(n) ? -5 : n;
  }

  /** Applied to parent `.acf-float` when `acf-float__input` has a value and passes field rules. */
  var ACF_FLOAT_VALID_CLASS = 'valite';

  function acfFloatInputPassesValidation(input) {
    if (!input || !input.name) return false;
    var v = String(input.value || '').trim();
    var name = input.name;
    if (name === 'first_name' || name === 'last_name') {
      return v.length > 0;
    }
    if (name === 'email') {
      return v.length > 0 && EMAIL_RE.test(v);
    }
    if (name === 'phone') {
      return v.length > 0;
    }
    if (name === 'order_id') {
      return v.length > 0;
    }
    if (name === 'sku') {
      return v.length > 0;
    }
    return false;
  }

  function setAcfFloatValidClassForInput(input) {
    if (!input || !input.classList || !input.classList.contains('acf-float__input')) {
      return;
    }
    var floatWrap = input.closest('.acf-float');
    if (!floatWrap) {
      return;
    }
    var manualWrap = input.closest('[data-amazon-sku-manual-wrap]');
    if (manualWrap && manualWrap.hasAttribute('hidden')) {
      floatWrap.classList.remove(ACF_FLOAT_VALID_CLASS);
      return;
    }
    if (acfFloatInputPassesValidation(input)) {
      floatWrap.classList.add(ACF_FLOAT_VALID_CLASS);
    } else {
      floatWrap.classList.remove(ACF_FLOAT_VALID_CLASS);
    }
  }

  function syncAllAcfFloatValidClasses(form) {
    if (!form) {
      return;
    }
    var inputs = form.querySelectorAll('.acf-float__input');
    var i;
    for (i = 0; i < inputs.length; i++) {
      setAcfFloatValidClassForInput(inputs[i]);
    }
  }

  function initAcfFloatValidClass(form) {
    if (!form) {
      return;
    }
    var inputs = form.querySelectorAll('.acf-float__input');
    var i;
    function onSync() {
      setAcfFloatValidClassForInput(this);
    }
    for (i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('input', onSync);
      inputs[i].addEventListener('blur', onSync);
    }
    form.addEventListener('reset', function () {
      syncAllAcfFloatValidClasses(form);
    });
    syncAllAcfFloatValidClasses(form);
  }

  function initEmailFieldError(form) {
    var input = form.querySelector('[name="email"]');
    var wrap = form.querySelector('[data-acf-email-wrap]');
    var errEl = form.querySelector('[data-acf-field-error="email"]');
    if (!input || !wrap) return;

    function clearEmailInvalid() {
      wrap.classList.remove('is-invalid');
      setAcfFieldErrorVisible(errEl, false);
    }

    input.addEventListener('input', function () {
      clearEmailInvalid();
    });
    input.addEventListener('focus', function () {
      clearEmailInvalid();
    });
    input.addEventListener('blur', function () {
      var v = String(input.value || '').trim();
      if (!v) return;
      if (!EMAIL_RE.test(v)) {
        wrap.classList.add('is-invalid');
        setAcfFieldErrorVisible(errEl, true, ACF_INLINE_ERR_EMAIL);
      }
    });
    form.addEventListener('reset', clearEmailInvalid);
  }

  /** Must match `asset_url` filename in warranty.liquid `data-channel-asset-anchor-url`. */
  var CHANNEL_LOGO_URL_ANCHOR = 'amazon-channel-klaviyo-form.js';

  function resolveThemeAssetFromAnchor(anchorUrl, fileName) {
    var u = String(anchorUrl || '').trim();
    var fn = String(fileName || '').trim();
    if (!u || !fn || u.indexOf(CHANNEL_LOGO_URL_ANCHOR) === -1) return '';
    return u.split(CHANNEL_LOGO_URL_ANCHOR).join(fn);
  }

  /**
   * Fills purchase channel <select> from JSON (avoids Liquid parse_json / empty options → "No matches").
   */
  function populatePurchaseChannelOptions(root, channelSelect) {
    if (!root || !channelSelect) return;
    var el = root.querySelector('script[type="application/json"][data-amazon-channel-defs]');
    if (!el) return;
    var raw = String(el.textContent || '').trim();
    if (!raw) return;
    var rows;
    try {
      rows = JSON.parse(raw);
    } catch (err) {
      console.error('[amazon-channel-form] Invalid purchase channel JSON', err);
      return;
    }
    if (!Array.isArray(rows) || !rows.length) return;
    var anchorUrl = String(root.getAttribute('data-channel-asset-anchor-url') || '').trim();
    while (channelSelect.options.length > 1) {
      channelSelect.remove(1);
    }
    var i;
    for (i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!row || typeof row !== 'object') continue;
      var key = String(row.channel_key || row.channelKey || '').trim();
      var name = String(row.channel_name || row.channelName || '').trim();
      if (!key || !name) continue;
      var opt = document.createElement('option');
      opt.value = key;
      opt.textContent = name;
      var logoFile = row.logo;
      // console.log(logoFile)
      if (logoFile && String(logoFile).trim()) {
        var resolved = resolveThemeAssetFromAnchor(anchorUrl, String(logoFile).trim());
        if (resolved) {
          opt.setAttribute('data-channel-logo', resolved);
        }
      }
      channelSelect.appendChild(opt);
    }
  }

  function init(root) {
    if (!root) return;
    var cfg = readConfig(root);
    var channelSelect = root.querySelector('[data-amazon-channel-select]');
    var skuSelect = root.querySelector('[data-amazon-sku-select]');
    var skuComboboxWrap = root.querySelector('[data-amazon-sku-combobox-wrap]');
    var form = root.querySelector('[data-amazon-channel-form]');
    var formMsg = root.querySelector('[data-amazon-form-message]');
    var termsWrap = root.querySelector('.amazon-channel-klaviyo-form__terms');
    var formBlock = root.querySelector('[data-amazon-channel-form-block]');
    var successPanel = root.querySelector('[data-amazon-channel-success]');
    var reviewModal = root.querySelector('[data-amazon-review-modal]');
    var reviewModalReviewNow = root.querySelector('[data-amazon-review-now]');
    var reviewModalDismiss = root.querySelector('[data-amazon-review-dismiss]');

    if (!channelSelect || !skuSelect || !form) return;

    populatePurchaseChannelOptions(root, channelSelect);

    channelSelect.__channelMetaMap = (function () {
      var map = Object.create(null);
      var ci;
      for (ci = 0; ci < channelSelect.options.length; ci++) {
        var co = channelSelect.options[ci];
        var cv = String(co.value || '').trim();
        if (!cv) continue;
        var logo = co.getAttribute('data-channel-logo');
        if (logo && String(logo).trim()) {
          map[cv] = { image: String(logo).trim() };
        }
      }
      return map;
    })();
    attachSearchableCombobox(channelSelect, { searchable: true, richChannel: true });
    skuSelect.__acfSkuPanel = { mode: 'need_channel' };
    skuSelect.__skuThumbPlaceholderUrl = SKU_THUMB_PLACEHOLDER_DATA_URL;
    attachSearchableCombobox(skuSelect, { richSku: true, searchable: true, inputTrigger: true });

    function getSkuTriggerInput() {
      var w = skuSelect && skuSelect.closest ? skuSelect.closest('[data-acf-combobox]') : null;
      var el = w && w.querySelector('[data-acf-combobox-trigger]');
      return el && el.tagName === 'INPUT' ? el : null;
    }

    function applySkuFieldMode() {
      if (!skuComboboxWrap || !skuSelect) {
        return;
      }
      var ch = String(channelSelect.value || '').trim();
      skuComboboxWrap.removeAttribute('hidden');
      var skuIn = getSkuTriggerInput();
      if (skuIn) {
        skuIn.disabled = !ch;
        if (!ch) {
          skuIn.value = '';
          skuIn.classList.add('is-placeholder');
        }
      }
      skuSelect.removeAttribute('required');
      syncAllAcfFloatValidClasses(form);
    }

    function getSkuValueForSubmit() {
      var skuIn = getSkuTriggerInput();
      var raw = skuIn ? String(skuIn.value || '').trim() : String(skuSelect.value || '').trim();
      return resolveSkuSelectValueToCanonical(skuSelect, raw);
    }

    initEmailFieldError(form);
    initAcfFloatValidClass(form);

    function refreshCombobox(sel) {
      if (sel && typeof sel.__acfComboboxRefresh === 'function') {
        sel.__acfComboboxRefresh();
      }
    }

    function resetSkuOptions(placeholder, skipRefresh) {
      skuSelect.innerHTML = '';
      skuSelect.__skuMetaMap = null;
      var opt0 = document.createElement('option');
      opt0.value = '';
      opt0.textContent = '';
      skuSelect.appendChild(opt0);
      if (!skipRefresh) {
        refreshCombobox(skuSelect);
      }
    }

    function onChannelChange() {
      var ch = String(channelSelect.value || '').trim();
      setFormMessage(formMsg, '', '');
      clearAcfInlineFieldErrors(form);
      if (!ch) {
        skuSelect.__acfSkuPanel = { mode: 'need_channel' };
        resetSkuOptions('Product SKU *');
        applySkuFieldMode();
        refreshCombobox(skuSelect);
        return;
      }

      applySkuFieldMode();
      var skuTi = getSkuTriggerInput();
      if (skuTi) {
        skuTi.value = '';
        skuTi.classList.add('is-placeholder');
        setAcfFloatValidClassForInput(skuTi);
      }
      skuSelect.__acfSkuPanel = { mode: 'loading' };
      resetSkuOptions('Select SKU');
      fetchSkusForChannel(cfg, resolveChannelKeyForApi(ch))
        .then(function (json) {
          var rows = parseSkuRows(json);
          resetSkuOptions('Select SKU', true);
          skuSelect.__skuMetaMap = Object.create(null);
          var i;
          for (i = 0; i < rows.length; i++) {
            var r = rows[i];
            var opt = document.createElement('option');
            opt.value = r.sku;
            opt.textContent = r.sku;
            skuSelect.appendChild(opt);
            skuSelect.__skuMetaMap[r.sku] = {
              channelSku: String(r.channelSku || '').trim(),
              image: r.image || '',
              link: r.link || '',
              category: r.category || '',
            };
          }
          if (rows.length === 0) {
            skuSelect.__acfSkuPanel = {
              mode: 'empty',
              message: 'No SKUs returned for this channel.',
            };
          } else {
            skuSelect.__acfSkuPanel = { mode: 'ready' };
          }
        })
        .catch(function (err) {
          console.error('[amazon-channel-form]', err);
          skuSelect.__acfSkuPanel = {
            mode: 'error',
            message: 'Could not load SKUs. Please try again.',
          };
          resetSkuOptions('Select SKU', true);
        })
        .then(function () {
          refreshCombobox(skuSelect);
        });
    }

    channelSelect.addEventListener('change', onChannelChange);
    if (channelSelect.value) {
      onChannelChange();
    } else {
      applySkuFieldMode();
    }

    function focusEl(el) {
      if (!el || typeof el.focus !== 'function') return;
      try {
        el.focus({ preventScroll: false });
      } catch (err) {
        try {
          el.focus();
        } catch (err2) {}
      }
    }

    function focusChannelTrigger() {
      var wrap = channelSelect && channelSelect.closest ? channelSelect.closest('[data-acf-combobox]') : null;
      var btn = wrap ? wrap.querySelector('[data-acf-combobox-trigger]') : null;
      focusEl(btn);
    }

    function focusSkuTrigger() {
      var wrap = skuSelect && skuSelect.closest ? skuSelect.closest('[data-acf-combobox]') : null;
      var btn = wrap ? wrap.querySelector('[data-acf-combobox-trigger]') : null;
      focusEl(btn);
    }

    function setTermsInvalid(v) {
      if (!termsWrap) return;
      if (v) {
        termsWrap.classList.add('is-invalid');
      } else {
        termsWrap.classList.remove('is-invalid');
      }
    }

    var termsElRef = form.querySelector('[name="terms_agree"]');
    if (termsElRef) {
      termsElRef.addEventListener('change', function () {
        if (termsElRef.checked) {
          setTermsInvalid(false);
        }
      });
      termsElRef.addEventListener('focus', function () {
        if (termsElRef.checked) {
          setTermsInvalid(false);
        }
      });
    }

    function focusTermsField() {
      setTermsInvalid(true);
      if (termsWrap && typeof termsWrap.scrollIntoView === 'function') {
        try {
          termsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } catch (err) {}
      }
      focusEl(termsElRef);
    }

    var reviewModalKeydownHandler = null;

    function closeAmazonReviewModal() {
      if (!reviewModal) return;
      reviewModal.setAttribute('hidden', '');
      reviewModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (reviewModalKeydownHandler) {
        document.removeEventListener('keydown', reviewModalKeydownHandler);
        reviewModalKeydownHandler = null;
      }
      try {
        if (successPanel) successPanel.focus();
      } catch (err1) {}
    }

    function openAmazonReviewModal(reviewHref) {
      if (!reviewModal) return;
      var href = String(reviewHref || '').trim();
      if (reviewModalReviewNow) {
        if (href) {
          reviewModalReviewNow.setAttribute('href', href);
          reviewModalReviewNow.removeAttribute('hidden');
        } else {
          reviewModalReviewNow.setAttribute('hidden', '');
        }
      }
      reviewModal.removeAttribute('hidden');
      reviewModal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (!reviewModalKeydownHandler) {
        reviewModalKeydownHandler = function (ev) {
          if (ev.key === 'Escape') {
            closeAmazonReviewModal();
          }
        };
        document.addEventListener('keydown', reviewModalKeydownHandler);
      }
      try {
        if (reviewModalDismiss) reviewModalDismiss.focus();
      } catch (err2) {}
    }

    if (reviewModal) {
      reviewModal.addEventListener('click', function (ev) {
        var reviewNowEl = ev.target.closest('[data-amazon-review-now]');
        if (reviewNowEl) {
          var reviewHref = String(reviewNowEl.getAttribute('href') || '').trim();
          if (!reviewHref || reviewHref === '#') {
            ev.preventDefault();
          }
          closeAmazonReviewModal();
          return;
        }
        if (ev.target.closest('[data-amazon-review-dismiss]')) {
          ev.preventDefault();
          ev.stopPropagation();
          closeAmazonReviewModal();
          return;
        }
        if (ev.target === reviewModal) {
          closeAmazonReviewModal();
        }
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      setFormMessage(formMsg, '', '');
      clearAcfInlineFieldErrors(form);
      setTermsInvalid(false);

      var firstName = form.querySelector('[name="first_name"]');
      var lastName = form.querySelector('[name="last_name"]');
      var emailEl = form.querySelector('[name="email"]');
      var emailWrap = form.querySelector('[data-acf-email-wrap]');
      var emailFieldErr = form.querySelector('[data-acf-field-error="email"]');
      var phoneEl = form.querySelector('[name="phone"]');
      var orderEl = form.querySelector('[name="order_id"]');
      var termsEl = termsElRef;

      var fn = firstName && firstName.value ? String(firstName.value).trim() : '';
      var ln = lastName && lastName.value ? String(lastName.value).trim() : '';
      var em = emailEl && emailEl.value ? String(emailEl.value).trim() : '';
      var phone = phoneEl && phoneEl.value ? String(phoneEl.value).trim() : '';
      var orderId = orderEl && orderEl.value ? String(orderEl.value).trim() : '';
      var ch = String(channelSelect.value || '').trim();
      var sku = getSkuValueForSubmit();
      var termsOk = termsEl && termsEl.checked;

      if (!fn) {
        setFormMessage(formMsg, 'error', 'Please enter your first name.');
        focusEl(firstName);
        return;
      }
      if (!ln) {
        setFormMessage(formMsg, 'error', 'Please enter your last name.');
        focusEl(lastName);
        return;
      }
      if (!em) {
        setFormMessage(formMsg, 'error', 'Please enter your email address.');
        focusEl(emailEl);
        return;
      }
      if (!EMAIL_RE.test(em)) {
        if (emailWrap) emailWrap.classList.add('is-invalid');
        setAcfFieldErrorVisible(emailFieldErr, true, ACF_INLINE_ERR_EMAIL);
        focusEl(emailEl);
        return;
      }
      if (!ch) {
        setFormMessage(formMsg, 'error', 'Please select a purchase channel.');
        focusChannelTrigger();
        return;
      }
      if (!sku) {
        setFormMessage(formMsg, 'error', 'Please enter or select a product SKU.');
        focusSkuTrigger();
        return;
      }
      if (!termsOk) {
        setFormMessage(formMsg, 'error', 'Please agree to the terms and policy.');
        focusTermsField();
        return;
      }

      var channelLabel = '';
      var si = channelSelect.selectedIndex;
      if (si >= 0 && channelSelect.options[si]) {
        channelLabel = String(channelSelect.options[si].textContent || '').trim();
      }

      var agreeLabel = String(cfg.klaviyoAgreeTermsLabel || 'Agree Warranty Terms').trim();
      if (!agreeLabel) {
        agreeLabel = 'Agree Warranty Terms';
      }
      var categoryDefault = String(cfg.klaviyoCategoryDefault || '').trim();
      var skuMeta = skuSelect.__skuMetaMap ? skuSelect.__skuMetaMap[sku] : null;
      var categoryVal = '';
      if (skuMeta && skuMeta.category) {
        categoryVal = String(skuMeta.category || '').trim();
      }
      if (!categoryVal) {
        categoryVal = categoryDefault;
      }

      var props = {
        $email: em,
        $first_name: fn,
        $last_name: ln,
        $source: parseKlaviyoProfileSource(cfg.klaviyoProfileSource),
        'Agree Warranty Terms': [agreeLabel],
        'Sales Channel': channelLabel,
        'SKU #': sku,
        'Order ID': orderId || '',
      };
      if (categoryVal) {
        props.Category = categoryVal;
      }

      if (phone) {
        props.Phone = phone;
        props.$phone_number = phone;
      }

      if (skuMeta) {
        if (skuMeta.link) {
          props['SKU Review Link'] = skuMeta.link;
        }
        if (skuMeta.image) {
          props['SKU Image URL'] = skuMeta.image;
        }
      }

      var identifyPayload = {
        $email: em,
        $first_name: fn,
        $last_name: ln,
      };
      if (phone) {
        identifyPayload.$phone_number = phone;
      }

      var listId = String(cfg.klaviyoListId || 'UU9HZ7').trim();
      var subPayload = buildKlaviyoClientSubscriptionPayload(
        listId,
        em,
        fn,
        ln,
        phone,
        props
      );

      var submitBtn = form.querySelector('button[type="submit"]');
      function setSubmitLoading(loading) {
        if (!submitBtn) {
          return;
        }
        submitBtn.disabled = !!loading;
        submitBtn.setAttribute('aria-busy', loading ? 'true' : 'false');
      }

      setSubmitLoading(true);
      setFormMessage(formMsg, '', '');

      klaviyoClientSubscribe(cfg, subPayload)
        .then(function () {
          window._learnq = window._learnq || [];
          window._learnq.push(['track', cfg.klaviyoEventName, props]);
          window._learnq.push(['identify', identifyPayload]);

          setFormMessage(formMsg, '', '');

          var skuAtSuccess = getSkuValueForSubmit();
          var skuReviewLink = '';
          if (skuSelect.__skuMetaMap && skuAtSuccess) {
            var sm = skuSelect.__skuMetaMap[skuAtSuccess];
            skuReviewLink = sm && sm.link ? String(sm.link).trim() : '';
          }

          form.reset();
          skuSelect.__acfSkuPanel = { mode: 'need_channel' };
          resetSkuOptions('Product SKU *');
          var skuTiReset = getSkuTriggerInput();
          if (skuTiReset) {
            skuTiReset.value = '';
            skuTiReset.classList.add('is-placeholder');
            setAcfFloatValidClassForInput(skuTiReset);
          }
          applySkuFieldMode();
          refreshCombobox(channelSelect);
          refreshCombobox(skuSelect);

          if (formBlock) {
            formBlock.setAttribute('hidden', '');
          }
          if (successPanel) {
            successPanel.removeAttribute('hidden');
            try {
              successPanel.focus();
            } catch (e1) {}
            try {
              successPanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } catch (e2) {}
          }
          if (skuReviewLink) {
            openAmazonReviewModal(skuReviewLink);
          }
        })
        .catch(function (err) {
          console.error('[amazon-channel-form] Klaviyo client subscription', err);
          setFormMessage(formMsg, 'error', formatKlaviyoSubscribeError(err));
        })
        .then(function () {
          setSubmitLoading(false);
        });
    });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-amazon-channel-form-root]');
    var i;
    for (i = 0; i < nodes.length; i++) {
      init(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
